import img1 from '../../images/learning/1.png'
import img2 from '../../images/learning/2.png'
// import img3 from '../../images/learning/3.png'
import img4 from '../../images/learning/4.png'
import img5 from '../../images/learning/5.png'
// import img6 from '../../images/learning/6.png'
// import img7 from '../../images/learning/7.png'
import img8 from '../../images/learning/8.png'

const learning = [
  {
    img: img1,
    id: '1',
    title: 'Learning',
    text: [
      'With KATON, you may learn at your own pace and with greater flexibility, both of which are essential for academic success. Virtual teamwork and communication that has been vastly enhanced... advanced technical proficiency, Because the internet knows no boundaries, students can take online courses from anywhere in the world.',
    ],
  },
  {
    img: img2,
    id: '2',
    title: 'Virtual Classroom',
    text: [
      'KATON virtual classroom is a web-based platform for instruction and student collaboration that allows for the dissemination of course materials and the promotion of social and intellectual exchange. Students learn superior time management skills in virtual classrooms since they are responsible for interacting with the material rather than just physically attending class. Therefore, students not only get knowledge from the curriculum, but also hone their skills in managing their time effectively.',
    ],
  },
  // {
  //   img: img3,
  //   id: '3',
  //   title: 'Social Forum',
  //   text: [
  //     'Aliquam faucibus, odio nec commodo aliquam, neque felis placerat dui, a porta ante lectus dapibus est. Aliquam a bibendum mi, sed condimentum est. Mauris arcu odio, vestibulum quis dapibus sit amet, finibus id turpis. Aliquam semper fringilla semper. Sed nec velit sit amet dolor pulvinar feugiat.',
  //     ' Suspendisse blandit, nulla sed interdum egestas, nibh ex maximus arcu, nonposuere sem nulla in augue. Class aptent taciti sociosqu ad litora torquent perconubia nostra, per inceptos himenaeos. Maecenas mattis sapien vel sollicitudinblandit. Donec nec porttitor eros. Praesent blandit, ',
  //   ],
  // },
  {
    img: img4,
    id: '3',
    title: 'Remedial class',
    text: [
      "Streaming Katon, Most children, including those with special needs, have access to remedial education programs, which re-teach fundamental skills in subjects like English, Mathematics and Science . Each student's progress in one particular skill or ability is a top priority in a remedial education program. Teachers help each student learn by adapting their teaching methods to their individual needs, which may include giving them more work to do, more time to practice, or more detailed explanations of concepts.",
    ],
  },
  {
    img: img5,
    id: '4',
    title: 'Past Question Paper',
    text: [
      "If you're looking for a convenient and inexpensive way to study for exams like the WASSCE, JAMB, NECO, and GCE, then go no further than KATON. In order to gauge how well you will do on the actual exam, doing practice questions is helpful. Students can evaluate their level of preparedness for a test by working through sample questions. It's a great tool for students taking exams that aim to gauge their mastery of course materials.",
    ],
  },
  // {
  //   img: img7,
  //   id: '5',
  //   title: 'Mobile app',
  //   text: [
  //     "KATON's mobile app provides constant, on-the-go access to cutting-edge educational methods, seamless parent-teacher contact, and a comprehensive, methodical framework. A learning app's advantages include knowledge extension, individualized lessons, increased interest and participation, study resources available 24/7, simple and quick communication, and, most importantly, remote access.",
  //   ],
  // },
  {
    img: img8,
    id: '6',
    title: 'eBook',
    text: [
      'We regularly update our e-books to keep up with the ever-changing publishing landscape, and because reading is central to so many pedagogical strategies, it is essential that students with varying reading needs, including those who are home-schooled or enrolled in online courses, have access to a variety of reading formats and support services. Our books are approved by NaCCA.',
    ],
  },
]
export default learning
